import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/grecaptcha/token.ts
var generateRecaptchaToken = (action = "unspecific") => __async(void 0, null, function* () {
  return new Promise((resolve, reject) => {
    var _a, _b;
    try {
      if (typeof grecaptcha === "undefined") {
        return reject("Error loading recaptcha, please refresh and try again.");
      }
      if (!((_b = (_a = ApiConfig.config) == null ? void 0 : _a.grecaptcha) == null ? void 0 : _b.v3Key)) {
        return reject(
          "No reCAPTCHA v3 key found in config, please follow usage instruction in https://github.com/nadude/webook-frontend/blob/main/packages/api/README.md"
        );
      }
      grecaptcha.ready(
        () => {
          var _a2, _b2;
          return grecaptcha.execute(((_b2 = (_a2 = ApiConfig.config) == null ? void 0 : _a2.grecaptcha) == null ? void 0 : _b2.v3Key) || "", { action }).then((token) => {
            resolve(token);
          });
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
});

export {
  generateRecaptchaToken
};
//# sourceMappingURL=chunk-W4XMZLKW.mjs.map